<script setup lang="ts">
  const { variant = "neutral", text } = defineProps<{
    variant?: "success" | "neutral" | "warning" | "error" | "black";
    text?: string;
  }>();
</script>

<template>
  <div :class="['tag', `tag-${variant}`]">
    <slot>{{ text }}</slot>
  </div>
</template>

<style scoped>
  .tag {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 4px 8px;
    width: fit-content;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0.12px;
  }

  .tag-neutral {
    background-color: var(--sf-tag-background-neutral);
    color: var(--sf-tag-text-neutral);
  }

  .tag-success {
    background-color: var(--sf-tag-background-success);
    color: var(--sf-tag-text-success);
  }

  .tag-warning {
    background-color: var(--sf-tag-background-warning);
    color: var(--sf-tag-text-warning);
  }

  .tag-error {
    background-color: var(--sf-tag-background-error);
    color: var(--sf-tag-text-error);
  }

  .tag-black {
    background-color: var(--sf-tag-background-black);
    color: var(--sf-tag-text-black);
  }
</style>
